import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DriverAppLog } from 'src/app/models/DriverAppLog.model';
import { CoreService } from '../../services/core/core.service';
import { UserProvider } from '../../services/providers/user-provider.ts/user-provider';
import { VehicleProvider } from '../../services/providers/vehicle-provider/vehicle-provider';
import { LogLevel } from 'src/app/helpers/enum/log-level.enum';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ErrorLoggingService } from '../error-logging/error-logging.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(
    private readonly coreService: CoreService,
    private readonly userProvider: UserProvider,
    private readonly vehicleProvider: VehicleProvider,
    private readonly router: Router,
    private readonly errorLogService: ErrorLoggingService
  ) { }

  handleError(error: any): void {
    if (error instanceof HttpErrorResponse) {
      let log = this.generateErrorLog(error, LogLevel.trace)
      this.errorLogService.addErrorLog(log).catch((err) => {
        console.error('Failed to enqueue HTTP error log', err);
      });
    }
    else if (environment.enableJsErrors) {
      let log = this.generateErrorLog(error, LogLevel.error)
      this.errorLogService.addErrorLog(log).catch((err) => {
        console.error('Failed to enqueue JS error log', err);
      });
    }
  }

  private generateErrorLog(error: any, logLevel: LogLevel) {
    const driverIdRaw = this.userProvider.readDriverData()?.driverId;
    const parsedDriverId = Number(driverIdRaw);
    const message =
      error?.message ??
      error?.statusText ??
      (typeof error === 'string' ? error : 'Unknown application error');
    const stackTrace = error?.stack ??
      (error?.error?.errors ? JSON.stringify(error.error.errors) : undefined) ??
      JSON.stringify(error);

    const errorLog: DriverAppLog = {
      driverId: Number.isFinite(parsedDriverId) ? parsedDriverId : null,
      icnNo: this.vehicleProvider.readSelectedVehicle()?.icN_NO ?? null,
      logDateUtc: new Date().toISOString(),
      logLevel: logLevel,
      applicationName: 'DRIVERAPP',
      appVersion: this.coreService.appVersion(),
      message: String(message),
      additionalInfo: stackTrace,
      eventId: globalThis.crypto?.randomUUID(),
      platformName: Capacitor.getPlatform().toUpperCase(),
      osVersion: this.coreService.osVersion(),
      deviceModel: this.coreService.deviceModel(),
      route: this.router.url || `${window.location.pathname}${window.location.search}${window.location.hash}`,
      networkState: navigator.onLine ? 'ONLINE' : 'OFFLINE',
    };

    return errorLog;
  }
}
